<template>
  <div>
    <v-sheet outlined class="pa-3 my-3" v-if="userBusinessInformation">
      <h4 class="blue--text mb-3">اطلاعات کسب و کار</h4>
      <v-row>
        <v-col cols="12">
          <div class="d-flex">
            <h5>نوع :</h5>
            <h5 class="mr-3 blue--text">
              {{
                userBusinessInformation.companyTypeGroupItemDto
                  .companyTypeGroupTitle
              }}
            </h5>

            <HelperComponent helperId="how-it-work-1120" />
          </div>
          <div v-if="showStatus">
            <h5 class="blue--text">
              {{
                userBusinessInformationStatus
                  ? `وضعیت: ${userBusinessInformationStatus}`
                  : ''
              }}
            </h5>
          </div>
        </v-col>
        <v-col cols="12" md="4" sm="6">
          <business-information-text-data
            label=" نام : "
            :text="userBusinessInformation.name"
          />
        </v-col>
        <template v-if="userBusinessInformation.company">
       <!--    <v-col cols="12" md="4" sm="6">
            <business-information-text-data
              label="نام :"
              :text="userBusinessInformation.company.name"
            />
          </v-col> -->
          <v-col cols="12" md="4" sm="6" v-if="companyTypeGroupId == 1">
            <business-information-text-data
              label="نوع شرکت:"
              :text="userBusinessInformation.company.companyTypeName"
            />
          </v-col>
          <v-col cols="12" md="4" sm="6" v-else>
            <business-information-text-data
              label="نوع ثبت:"
              :text="userBusinessInformation.company.companyTypeName"
            />
          </v-col>
  <!--         <v-col cols="12" md="4" sm="6" v-if="companyTypeGroupId == 1">
            <business-information-text-data
              label="عنوان برند:"
              :text="userBusinessInformation.company.brandName"
            />
          </v-col> -->
          <v-col cols="12" md="4" sm="6" v-if="companyTypeGroupId == 1">
            <business-information-text-data
              label="شناسه ملی:"
              :text="userBusinessInformation.company.nationalId"
            />
          </v-col>
          <v-col cols="12" md="4" sm="6" v-if="companyTypeGroupId == 1">
            <business-information-text-data
              label="شناسه ثبت:"
              :text="userBusinessInformation.company.registrarNumber"
            />
          </v-col>
          <v-col cols="12" md="4" sm="6" v-if="companyTypeGroupId == 1">
            <business-information-text-data
              label="کد اقتصادی:"
              :text="userBusinessInformation.company.economicCode"
            />
          </v-col>

          <v-col cols="12" md="4" sm="6" v-if="companyTypeGroupId == 2">
            <business-information-text-data
              label="کد آیسیک:"
              :text="userBusinessInformation.company.isic"
            />
          </v-col>
          <v-col cols="12" md="4" sm="6" v-if="companyTypeGroupId == 2">
            <business-information-text-data
              label="شناسه صنفی:"
              :text="userBusinessInformation.company.guildId"
            />
          </v-col>
          <v-col cols="12" md="4" sm="6">
            <business-information-text-data
              label="اندازه:"
              :text="merchantSizeTypeLabel"
            />
          </v-col>
          <v-col cols="12" md="4" sm="6">
            <business-information-text-data
              label="نوع فعالیت:"
              :text="categoryTypesNames"
            />
          </v-col>
        </template>
        <span v-else class="text--secondary">(وارد نشده)</span>
        <v-col cols="12" md="4" sm="6">
          <business-information-text-data
            label="ایمیل:"
            :text="userBusinessInformation.email"
          />
        </v-col>
        <v-col cols="12" md="4" sm="6">
          <business-information-text-data
            label="افراد دارای حق امضاء:"
            :text="userBusinessInformation.permittedSignerNames"
          />
        </v-col>
      </v-row>
    </v-sheet>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import { RepoFactory } from '@/baseRepository/Factory';
import Helper from '@/core/helpers';
const enumsRepository = () => RepoFactory.get('enums');
import BusinessInformationTextData from './BusinessInformationTextData.vue';
export default {
  components: {
    BusinessInformationTextData,
  },
  props: {
    userBusinessInformation: {
      type: Object,
      default: null,
    },
    showStatus: {
      type: Boolean,
      default: null,
    },
  },
  data() {
    return {
      merchantSizeTypeList: [],
      categoryTypeItemsList: [],
      merchantStatusList: [],
    };
  },
  computed: {
    ...mapGetters(['productBaseUrl', 'merchantBaseUrl']),
    merchantSizeTypeLabel() {
      if (this.userBusinessInformation.merchantSize) {
        const element = this.merchantSizeTypeList.find(
          (el) => el.title == this.userBusinessInformation.merchantSize
        );
        if (element) {
          return element.displayName;
        }
      }
      return '';
    },
    categoryTypesNames() {
      if (this.categoryTypeItemsList.length) {
        let arr = [];
        this.userBusinessInformation.categoryTypes.forEach((element) => {
          const ele = this.categoryTypeItemsList.find(
            (el) => el.title == element
          );
          arr.push(ele.displayName);
        });

        return arr.join(',');
      }
      return '';
    },
    companyTypeGroupId() {
      return this.userBusinessInformation.companyTypeGroupItemDto
        .companyTypeGroupId;
    },
    userBusinessInformationStatus() {
      if (this.userBusinessInformation) {
        const statusObj = this.merchantStatusList.find(
          (el) => el.title === this.userBusinessInformation.status
        );
        if (statusObj) return statusObj.displayName;
        return '';
      }
    },
  },
  created() {
    this.getMerchantSizeTypeList();
    this.getCategoryTypeItems();
    if (this.showStatus) {
      this.getMerchantStatusList();
    }
  },
  methods: {
    getMerchantStatusList() {
      const loader = this.$loading.show();
      enumsRepository()
        .getEnum('MerchantStatus', this.merchantBaseUrl)
        .then(({ data }) => {
          this.merchantStatusList = data;
        })
        .catch((error) => {
          Helper.handleErrors(error, this);
        })
        .finally(() => {
          loader.hide();
        });
    },
    getMerchantSizeTypeList() {
      const loader = this.$loading.show();
      enumsRepository()
        .getEnum('MerchantSizeType', this.merchantBaseUrl)
        .then(({ data }) => {
          this.merchantSizeTypeList = data;
        })
        .catch((error) => {
          Helper.handleErrors(error, this);
        })
        .finally(() => {
          loader.hide();
        });
    },
    getCategoryTypeItems() {
      const loader = this.$loading.show();
      enumsRepository()
        .getEnum('CategoryTypeItems', this.productBaseUrl)
        .then(({ data }) => {
          this.categoryTypeItemsList = data;
        })
        .catch((error) => {
          Helper.handleErrors(error, this);
        })
        .finally(() => {
          loader.hide();
        });
    },
  },
};
</script>

<style></style>
